/* eslint-disable */
<template>
  <div id="app">
    <div id="loader" :class="{ hidden: !loading }"></div>
    <div id="background"></div>
    <div id="header" :class="{
      top: top <= height / 3,
      bottom: top > height / 3
    }">
      <div id="menu" :class="{ active: active }" @click="active = !active">
        <div>
          <div :style="{ backgroundColor: pageColor.primary }"></div>
          <div :style="{ backgroundColor: pageColor.primary }"></div>
          <div :style="{ backgroundColor: pageColor.primary }"></div>
        </div>
      </div>
      <div id="logo">
        <a href="#landing" v-smooth-scroll>
          <img src="./assets/logo.png" />
        </a>
      </div>
      <div id="name">Insight Therapy and Counselling</div>
      <div id="navigation" :class="{ active: active }">
        <a class="nav" style="color: #4a6a91" href="#welcome" v-smooth-scroll>
          Welcome
        </a>
        <a class="nav" style="color: #634a91" href="#therapy" v-smooth-scroll>
          Therapy
        </a>
        <a class="nav" style="color: #00828c" href="#counselling" v-smooth-scroll>
          Counselling
        </a>
        <a class="nav" style="color: #9e3661" href="#fees" v-smooth-scroll>
          Fees and Rebates
        </a>
        <a class="nav" style="color: #9e005d" href="#contact" v-smooth-scroll>
          Contact
        </a>
        <div id="indicator" :style="{ backgroundColor: pageColor.primary }"></div>
      </div>
      <div class="back"></div>
    </div>
    <div id="pages" :class="{ active: active }">
      <div id="landing" class="page" @click="active = false">
        <img style="
            position: absolute;
            left: 0;
            bottom: -1px;
            width: 100%;
            height: auto;
          " src="./assets/ground.svg" />
      </div>
      <div id="welcome" class="page" style="
          border-top: 1rem solid #dee1e5;
          border-bottom: 1rem solid #4a6a91;
        " :style="{ borderBottomColor: pageColor.secondary }" @click="active = false">
        <div class="content">
          <h1 class="title" style="color: #00828c" :style="{ color: pageColor.primary }">
            Welcome
          </h1>
          <div class="text">
            <div class="grid full">
              <p>
                Insight Therapy and Counselling offers psychological therapy and life counselling to individuals, couples
                and families as well as runs support groups for women.
              </p>
              <p>&nbsp;</p>
              <p style="
                  margin-top: 0;
                  font-size: 2em;
                  line-height: 0.8;
                  color: #4a6a91;
                  font-weight: 600;
                ">
                Helen McBride<br /><span style="font-size: 0.6em; color: #828282; font-weight: 300">Counselling
                  Psychologist M Soc Sci (Counselling Psych) Grad
                  Dip Ed</span>
              </p>
              <div id="profile">
                <img src="./assets/helen-profile.jpeg" />
              </div>
              <p>I believe that for people to have the freedom to create and enjoy a meaningful and engaged life sometimes
                they need to attend to deeper emotional issues, but at other times, they might need support and tools to
                deal with a stressful life event or to clarify or reset their life direction and move forward with their
                lives.</p>
              <p>People come to me for help for a range of mental health difficulties as well as for a space to talk and
                reflect on their lives and perhaps reset their life direction or enhance their enjoyment of life.</p>
              <p>While I work with a range of mental health challenges, I have particular interest, expertise and
                experience in psychological trauma, couples counselling and assisting women with life changes and
                transitions.</p>
              <blockquote>
                <span :style="{ color: pageColor.primary }">“The good life is a process, not a state of being. It is a
                  direction, not a destination”</span><span>- Carl Rogers</span>
              </blockquote>
            </div>
          </div>
        </div>
        <div class="pattern"></div>
      </div>
      <div id="therapy" class="page" style="background-color: #634a91" :style="{
        backgroundColor: pageColor.primary,
        borderColor: pageColor.secondary,
      }" @click="active = false">
        <div class="content">
          <h1 class="title" style="color: #fff">Therapy</h1>
          <div class="text" style="color: #fff">
            <div class="grid full">
              <div class="grid half">
                <p>
                  In individual and couples sessions I collaborate with you to understand the impact your area of
                  difficulty is having on your work, study, relationships or enjoyment of life in general and make a plan
                  to help you move beyond these difficulties.
                </p>
                <p>
                  I have a Master's degree in Counselling Psychology which provided me with a foundation in the theory and
                  application of a range of therapeutic models, such as Cognitive Behavioural Therapy, Interpersonal
                  Therapy and Psychodynamic Therapy. In addition, I have completed subsequent training in Eye Movement
                  Desensitisation Reprocessing (EMDR), the Gottman Method of Couples Therapy (Level 1) and Emotionally
                  Focussed Therapy for Couples. This gives me a range of approaches to draw from depending on your
                  particular needs and preferences.
                </p>
              </div>
              <div class="grid half">
                <p>Some mental health challenges might include:</p>
                <ul>
                  <li>
                    Anxiety and stress related difficulties (including panic
                    attacks)
                  </li>
                  <li>Depression</li>
                  <li>Relationship difficulties</li>
                  <li>ADHD</li>
                  <li>
                    Post traumatic stress (arising from one-off incidents, such
                    as robbery, accident, assault or witnessing violence)
                  </li>
                  <li>
                    Post-traumatic stress resulting from combat experience
                  </li>
                  <li>Effects of childhood physical and emotional abuse</li>
                  <li>Bereavement or grief</li>
                </ul>
              </div>
            </div>
            <div class="grid full">
              <div class="grid half">
                <h3>My Therapeutic “Toolbox”</h3>
                <p>
                  I do not believe that one mode of therapy suits all people and their situations, so I combine different
                  modes at various stages in therapy. For example, to treat elevated anxiety, I’ll use Cognitive
                  Behavioural Therapy to help you to identify and manage unhelpful thoughts and underlying negative core
                  beliefs, Short-term Psychodynamic Therapy and Emotionally Focused Therapy (EFT), to help you identify
                  old patterns of behaviour you have used to cope with difficult emotions and develop new more effective
                  ones. At other times, I might use Interpersonal Therapy to help you develop new skills in your
                  relationships, such as boundary-setting and being more assertive or use the concept of Character
                  Strengths from Positive Psychology to help you build a stronger sense of self, self-efficacy and
                  resilience. It all depends on what you come for and what you would like to get out of the process.
                </p>
              </div>
              <div class="grid half">
                <h3>Eye Movement Desensitization Reprocessing (EMDR)</h3>
                <p>
                  EMDR is a complex method of psychotherapy that integrates many
                  of the successful elements of a range of therapeutic
                  approaches, and combines them with eye movements or other
                  forms of bilateral stimulation in ways that appear to
                  stimulate the brain's information processing system.
                </p>
                <p>
                  EMDR has been used and successfully helped many people who
                  have had psychological difficulties that originate from some
                  kind of traumatic experience, such as sexual abuse, childhood
                  neglect, road traffic accidents, combat and/or violence. In
                  addition to PTSD, EMDR is also used to treat other mental
                  health issues such as anxiety and panic disorder.
                </p>
                <p>
                  <a href="https://www.emdria.org/about-emdr-therapy/" target="_blank"
                    title="EMDR International Association">More Information</a>
                </p>
              </div>
            </div>
            <div class="grid full" style="padding: 0px">
              <div class="grid full">
                <h3>Couples Counselling</h3>
              </div>
              <div class="grid half">
                <p>
                  During couples counselling I focus on your interaction and communication styles as well as the
                  underlying emotion and attachment needs which influence behaviour. So for example, depending on your
                  circumstances, you might benefit from learning how to productively handle conflict, foster more
                  connectedness and shared meaning or build an atmosphere of safety in the relationship. Whatever, the
                  issue, we will work together to understand what would be most useful for you both.
                </p>
              </div>
              <div class="grid half">
                <p>
                  I allow for a 90-minute appointment for couple's counselling. I see you together the first session to
                  understand what you would like from the counselling and do an initial assessment. If you decide that
                  you
                  would like to continue, the next time, I see you individually for 45 mins each. This gives me an
                  opportunity to understand your individual family backgrounds and gain a deeper understanding of what
                  is
                  important to you in the relationship. All subsequent sessions are conjoint sessions.
                </p>
                <p>
                  I am informed by both The Gottman Method of couples counselling and Emotionally Focussed Therapy for
                  Couples.
                </p>
              </div>
            </div>
            <div class="grid full" style="padding: 0px">
              <div class="grid half">
                <h3>The Gottman Method of Couples Counselling</h3>
                <p>
                  John and Julie Gottman are leading researchers and practitioners in the field of couples counselling.
                  Their method provides a framework for understanding the elements of a good relationship and a path to
                  incorporating these elements into your relationship and so reducing destructive behaviours.
                </p>
                <p>
                  <a href="https://www.gottman.com/about/the-gottman-method/" target="_blank"
                    title="The Gottman Method">More Information</a>
                </p>
              </div>
              <div class="grid half">
                <h3>Emotionally Focussed Therapy for Couples</h3>
                <p>
                  Couples seeking counselling are often experiencing unhelpful patterns of interaction in their
                  relationship which over time tend to create distance and dissatisfaction. Emotionally Focussed Therapy
                  for Couples is based on attachment theory and focuses on helping people communicate and regulate
                  underlying emotions in their interactions to achieve a more secure bond with their partner.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="pattern"></div>
      </div>
    </div>
    <div id="counselling" class="page" style="border-top: 1rem solid #00828c; overflow: hidden"
      :style="{ borderColor: pageColor.secondary }" @click="active = false">
      <div class="content">
        <h1 class="title" style="color: #00828c" :style="{ color: pageColor.primary }">
          Life Counselling
        </h1>
        <h2 class="sub-title">space to talk, reflect and go forward</h2>
        <div class="text">
          <div class="grid full">
            <div class="grid half">
              <p>
                The one thing that is certain about life is change. And even
                if it is welcome or 'good' change, it can still present
                challenges. You might be in a period of transition,
                experiencing some change in your life or simply want to get
                more out of your life at present.
              </p>
              <p>
                Whatever the reason, the aim of life counselling is to give
                you time and space to reflect, raise your awareness of your
                inherent character strengths and use your life experience,
                values and hopes to reset your direction in life or enhance
                your experience of life.
              </p>
            </div>
            <div class="grid half">
              <p>
                Some examples of the types of things that I can assist you with are:
              </p>
              <ul>
                <li>Adjustment to role changes associated with:</li>
                <ul>
                  <li>a new job</li>
                  <li>retirement</li>
                  <li>a relationship break-up</li>
                  <li>a new relationship</li>
                  <li>becoming a parent</li>
                  <li>children leaving home</li>
                  <li>aging parents</li>
                </ul>
                <li>Parenting – parenting skills</li>
                <li>Moving to or from interstate or overseas</li>
              </ul>
            </div>
          </div>
          <div class="grid full">
            <div class="grid thrd">
              <h3 :style="{ color: pageColor.primary }">
                Positive Psychology
              </h3>
              <p>
                Positive Psychology is concerned with the study of what makes
                a good life. According to Martin Seligman, five elements
                provide the foundation for a feeling of wellbeing: Positive
                Emotion, Engagement, Relationships, Meaning and Accomplishment
                (PERMA).
              </p>
              <p>
                You can learn ways of increasing the presence of these
                elements in your life to a degree that will result in you
                feeling better about yourself, your life and your capacity to
                meet the inevitable challenges of life.
              </p>
              <p>
                <a :style="{ color: pageColor.primary + ' !important' }"
                  href="https://ppc.sas.upenn.edu/learn-more/perma-theory-well-being-and-perma-workshops" target="_blank"
                  title="Positive Psychology Center">More Information</a>
              </p>
            </div>
            <div class="grid thrd">
              <h3 :style="{ color: pageColor.primary }">
                Women and Adjustment
              </h3>
              <p>
                As women, we spend a large chunk of our adulthood focussing
                the important tasks of family, children and work. At times
                life can feel like a balancing act between our needs and the
                needs of others, but is at least a stable balancing act. And
                then we can wake up one day to find that our familiar roles
                are changing or disappearing as the lives of those close to us
                change: a relationship ends, children leave home, menopause
                hits, our working lives begin to wind down.
              </p>
              <p>
                Change disrupts but it also gives us the freedom to choose to
                do things differently.
              </p>
            </div>
            <div class="grid thrd">
              <h3 :style="{ color: pageColor.primary }">
                Change, loss and grief
              </h3>
              <p>
                It doesn't matter what kind of change you are going through,
                the process tends to remain the same. Changes in our lives
                invariably involve a sense of loss, even if it is 'welcome
                change' and the stages of change can resemble the stages of
                grief. Even though it is uncomfortable, it is important that
                you recognise and acknowledge what you are experiencing and
                feeling as much as possible so that you can happily move
                forward with your life. Obtaining support from family, friends
                or counsellor will help you get through the process more
                easily.
              </p>
            </div>
          </div>
        </div>
      </div>
      <img id="tree" src="./assets/tree.svg" />
    </div>
    <div id="fees" class="page" style="
          background-color: #9e3661;
          color: #fff;
          border-top: 1rem solid #a84a70;
        " :style="{
          backgroundColor: pageColor.primary,
          borderColor: pageColor.secondary,
        }" @click="active = false">
      <div class="content">
        <h1 class="title">Fees and Rebates</h1>
        <div class="text">
          <div class="grid full">
            <div class="grid half">
              <p>Individual counselling (60 minutes) - $240</p>
              <p>Couples/Family counselling (90 minutes) - $300</p>
              <p>GP MHCP Review letters - $50</p>
              <p>Other reports to third-party bodies at clients’ request - $150 per hour</p>
            </div>
            <div class="grid half">
              <p>If you are referred by a GP or Psychiatrist under the Better Access to Mental Health Care Initiative, and
                are coming for individual sessions, you are eligible for a Medicare rebate of $93.35 for each session for
                up to 10 sessions a year.</p>
              <p>Following the first six sessions, you need to attend your GP for a review to access the other four
                sessions. I am required to write a brief report to the GP, which forms the basis of that review.</p>
              <p>Couples and Family counselling is not eligible for a Medicare rebate.</p>
              <p>You do not need a referral to receive psychotherapy or counselling (self-referral). In this case you may
                be eligible for a rebate from your private health fund. Contact your fund to check if you are covered.</p>
            </div>
          </div>
        </div>
      </div>
      <svg class="visual" viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1">
        <path
          d="M0 402L21.5 403.7C43 405.3 86 408.7 128.8 408.5C171.7 408.3 214.3 404.7 257.2 404.7C300 404.7 343 408.3 385.8 412C428.7 415.7 471.3 419.3 514.2 415.3C557 411.3 600 399.7 642.8 396.5C685.7 393.3 728.3 398.7 771.2 407C814 415.3 857 426.7 878.5 432.3L900 438L900 601L878.5 601C857 601 814 601 771.2 601C728.3 601 685.7 601 642.8 601C600 601 557 601 514.2 601C471.3 601 428.7 601 385.8 601C343 601 300 601 257.2 601C214.3 601 171.7 601 128.8 601C86 601 43 601 21.5 601L0 601Z"
          fill="#ffffff"></path>
        <path
          d="M0 467L21.5 456.7C43 446.3 86 425.7 128.8 426.3C171.7 427 214.3 449 257.2 456.7C300 464.3 343 457.7 385.8 450.2C428.7 442.7 471.3 434.3 514.2 432C557 429.7 600 433.3 642.8 437.2C685.7 441 728.3 445 771.2 442.3C814 439.7 857 430.3 878.5 425.7L900 421L900 601L878.5 601C857 601 814 601 771.2 601C728.3 601 685.7 601 642.8 601C600 601 557 601 514.2 601C471.3 601 428.7 601 385.8 601C343 601 300 601 257.2 601C214.3 601 171.7 601 128.8 601C86 601 43 601 21.5 601L0 601Z"
          fill="#d8d8d8"></path>
        <path
          d="M0 451L21.5 460.5C43 470 86 489 128.8 491C171.7 493 214.3 478 257.2 473.7C300 469.3 343 475.7 385.8 481.2C428.7 486.7 471.3 491.3 514.2 485.2C557 479 600 462 642.8 459C685.7 456 728.3 467 771.2 473.2C814 479.3 857 480.7 878.5 481.3L900 482L900 601L878.5 601C857 601 814 601 771.2 601C728.3 601 685.7 601 642.8 601C600 601 557 601 514.2 601C471.3 601 428.7 601 385.8 601C343 601 300 601 257.2 601C214.3 601 171.7 601 128.8 601C86 601 43 601 21.5 601L0 601Z"
          fill="#b2b2b2"></path>
        <path
          d="M0 482L21.5 487.3C43 492.7 86 503.3 128.8 513.3C171.7 523.3 214.3 532.7 257.2 529.7C300 526.7 343 511.3 385.8 503.3C428.7 495.3 471.3 494.7 514.2 494.8C557 495 600 496 642.8 495.7C685.7 495.3 728.3 493.7 771.2 496C814 498.3 857 504.7 878.5 507.8L900 511L900 601L878.5 601C857 601 814 601 771.2 601C728.3 601 685.7 601 642.8 601C600 601 557 601 514.2 601C471.3 601 428.7 601 385.8 601C343 601 300 601 257.2 601C214.3 601 171.7 601 128.8 601C86 601 43 601 21.5 601L0 601Z"
          fill="#8e8e8e"></path>
        <path
          d="M0 566L21.5 564.3C43 562.7 86 559.3 128.8 558.7C171.7 558 214.3 560 257.2 558.5C300 557 343 552 385.8 550.7C428.7 549.3 471.3 551.7 514.2 547.8C557 544 600 534 642.8 533.8C685.7 533.7 728.3 543.3 771.2 550.8C814 558.3 857 563.7 878.5 566.3L900 569L900 601L878.5 601C857 601 814 601 771.2 601C728.3 601 685.7 601 642.8 601C600 601 557 601 514.2 601C471.3 601 428.7 601 385.8 601C343 601 300 601 257.2 601C214.3 601 171.7 601 128.8 601C86 601 43 601 21.5 601L0 601Z"
          fill="#6b6b6b"></path>
      </svg>
      <div class="pattern"></div>
    </div>
    <div id="contact" class="page" @click="active = false">
      <!-- <div style="background-color: #9e005d; height: 6rem; width: 100%" :style="{ backgroundColor: pageColor.primary }">
              <div class="pattern"></div>
          </div> -->
      <div class="pattern"></div>
      <div class="content">
        <h1 class="title" style="color: #9e005d" :style="{ color: pageColor.primary }">
          Contact
        </h1>
        <div class="text">
          <div class="grid half">
            <p>
              To make an enquiry or arrange an appointment, you can phone or
              email Helen on:
            </p>
            <p><strong>Phone: </strong>08 6263 4452</p>
            <p><strong>Mobile (SMS): </strong>0478 577400</p>
            <p>
              <strong>Email: </strong><a href="mailto:info@insighttherapy.com.au">info@insighttherapy.com.au</a>
            </p>
            <p>
              <strong>Practice Hours: </strong><br />Tuesdays, Wednesdays and
              Fridays: 8 am to 6:30 pm
            </p>
          </div>
          <div class="grid half">
            <p>Insight Therapy and Counselling is located at:</p>
            <p>Suite 38, 44 Kings Park Road, West Perth, 6005</p>
            <img class="assoc" src="./assets/acp_member.png" />
          </div>
        </div>
      </div>
      <iframe width="600" height="300" frameborder="0" style="display: block; width: 100%; border: 0"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d846.3373025364212!2d115.83675586493374!3d-31.951421711660146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32a524e120749f%3A0xee05ca03d3cc2695!2s44%20Kings%20Park%20Rd%2C%20West%20Perth%20WA%206005!5e0!3m2!1sen!2sau!4v1610725971379!5m2!1sen!2sau"
        allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      <div id="footer" style="background-color: #9e005d" :style="{ backgroundColor: pageColor.primary }">
        &copy; Insight Therapy {{ new Date().getFullYear() }}
        <div></div>
      </div>
    </div>
  </div>
</div></template>

<script>
function addEvent(obj, type, callback) {
  if (obj === null || typeof obj === 'undefined') return
  if (obj.addEventListener) {
    obj.addEventListener(type, callback, false)
  } else if (obj.attachEvent) {
    obj.attachEvent('on' + type, callback)
  } else {
    obj['on' + type] = callback
  }
}

export default {
  name: 'app',
  data() {
    return {
      loading: true,
      active: false,
      currentPage: 0,
      pages: null,
      pageVals: [],
      pageColor: {
        primary: '#4a6a91',
        secondary: '#527095'
      },
      pageColors: [
        {
          primary: '#4a6a91',
          secondary: '#527095'
        },
        {
          primary: '#4a6a91',
          secondary: '#5b789b'
        },
        {
          primary: '#634a91',
          secondary: '#695295'
        },
        {
          primary: '#00828c',
          secondary: '#198e97'
        },
        {
          primary: '#9e3661',
          secondary: '#a84a70'
        },
        {
          primary: '#9e005d',
          secondary: '#8f0054'
        }
      ],
      width: 0,
      height: 0,
      top: 0
    }
  },
  watch: {
    currentPage: function (page) {
      let pageArr = document.getElementsByClassName('page')
      for (let i = 0; i < pageArr.length; i++) {
        if (i === page) {
          pageArr[i].classList.add('current')
        } else {
          pageArr[i].classList.remove('current')
        }
      }
    }
  },
  mounted: function () {
    this.pages = document.getElementById('pages')
    let ind = document.getElementById('indicator')
    let nav = document.getElementById('navigation')
    let background = document.getElementById('background')
    let pages = document.getElementsByClassName('page')
    this.currentPage = 0
    let scrollTriggers = (ev) => {
      let scroll =
        window.scrollTop ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.top = scroll
      let findPage = (top) => {
        for (let i = 0; i < this.pageVals.length; i++) {
          if (top < this.pageVals[i]) {
            if (
              top >
              this.pageVals[Math.max(i - 1, 0)] +
              (this.pageVals[i] - this.pageVals[Math.max(i - 1, 0)]) * 0.65
            ) {
              return i
            } else {
              return Math.max(i - 1, 0)
            }
          }
        }
      }
      let page = findPage(scroll)
      if (page !== this.currentPage && page >= 1) {
        this.currentPage = page
        this.pageColor = this.pageColors[page]
        ind.style.height = nav.children[page - 1].offsetHeight + 'px'
        ind.style.top = nav.children[page - 1].offsetTop + 'px'
        if (history.pushState) {
          window.history.pushState(
            'object or string',
            'Title',
            nav.children[page - 1].href
          )
        } else {
          document.location.href = nav.children[page - 1].href
        }
        background.classList = ''
        background.classList.add(pages[page].id)
      } else if (page !== this.currentPage && page === 0) {
        this.currentPage = page
        if (history.pushState) {
          window.history.pushState('object or string', 'Title', '#')
        } else {
          document.location.href = '#'
        }
        background.classList = ''
        background.classList.add('landing')
      }
    }

    let windowResize = () => {
      let d = document
      let g = d.body || d.getElementsByTagName('body')[0]
      this.width =
        window.innerWidth || d.documentElement.clientWidth || g.clientWidth
      this.height =
        window.innerHeight || d.documentElement.clientHeight || g.clientHeight
      let pages = d.getElementsByClassName('page')
      this.pageVals = Array.from(pages, (page) => {
        // console.log(page.offsetTop)
        return Math.max(page.offsetTop)
      })
      scrollTriggers()
    }
    windowResize()
    // Window resize call reize function with debounce
    addEvent(window, 'resize', windowResize)

    addEvent(window, 'scroll', scrollTriggers)
    scrollTriggers()
    setTimeout(() => {
      this.loading = false
    }, 100)
  },
  methods: {
    convertRemToPx: function (rem) {
      return (
        rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
      )
    }
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;600;700;800&display=swap");

body {
  margin: 0;
}

#app {
  font-family: "Raleway", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #262626;
  width: 100%;
  height: 100vh;
}

#map {
  display: none;
}

/* Header */

#header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 90;
  opacity: 1;
  height: auto;
  padding: 0.5rem 0 0.5rem 0;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}

#header>.back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffffd9;
  opacity: 1;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: -1;
}

#header.top>.back {
  opacity: 0;
}

/* #header.top {
    opacity: 0;
    pointer-events: none;
} */

#header #logo {
  display: block;
  position: relative;
  height: 40vh;
  width: auto;
  clear: both;
  margin-right: auto;
  margin-left: auto;
  cursor: default;
  transition: height 0.3s ease-out;
  -o-transition: height 0.3s ease-out;
  -ms-transition: height 0.3s ease-out;
  -moz-transition: height 0.3s ease-out;
  -webkit-transition: height 0.3s ease-out;
}

#header.bottom #logo {
  height: 3rem;
  width: auto;
  cursor: pointer;
}

#header #logo>a {
  display: block;
  height: 100%;
  position: relative;
  clear: both;
  margin-right: auto;
  margin-left: auto;
}

#header #logo img {
  position: relative;
  width: auto;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
}

#header.bottom>.back {
  opacity: 1;
}

#header #name {
  font-size: 3rem;
  font-weight: 300;
  color: #464646;
  width: 100%;
  height: auto;
  margin-bottom: 0.5rem;
  padding: 0rem 1rem 1rem 1rem;
  box-sizing: border-box;
  overflow: hidden;
  transition: height 0.3s ease-out, margin-bottom 0.3s ease-out;
  -o-transition: height 0.3s ease-out, margin-bottom 0.3s ease-out;
  -ms-transition: height 0.3s ease-out, margin-bottom 0.3s ease-out;
  -moz-transition: height 0.3s ease-out, margin-bottom 0.3s ease-out;
  -webkit-transition: height 0.3s ease-out, margin-bottom 0.3s ease-out;
}

#header.bottom #name {
  height: 0rem;
  margin-bottom: 0rem;
  padding: 0;
}

#navigation {
  position: absolute;
  top: 100%;
  left: 1rem;
  width: 10rem;
  margin-top: 1rem;
  padding: 0rem 1rem 0rem 1rem;
  margin-right: auto;
  margin-left: auto;
  border-radius: 3px;
  box-sizing: border-box;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-top: 0px solid #8c8c8c;
  transition-property: transform, -moz-transform, -webkit-transform;
  -o-transition-property: transform, -moz-transform, -webkit-transform;
  -ms-transition-property: transform, -moz-transform, -webkit-transform;
  -moz-transition-property: transform, -moz-transform, -webkit-transform;
  -webkit-transition-property: transform, -moz-transform, -webkit-transform;
  transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
  -ms-transition-duration: 0.2s;
  -moz-transition-duration: 0.2s;
  -webkit-transition-duration: 0.2s;
  transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  -ms-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -webkit-transition-timing-function: ease-out;
}

#header.bottom>#navigation {
  background-color: #ffffffd9;
  opacity: 0;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transform: translateX(-150%);
  -moz-transform: translateX(-150%);
  -webkit-transform: translateX(-150%);
}

#header.bottom>#navigation.active {
  opacity: 1;
  transform: translateX(0%);
  -moz-transform: translateX(0%);
  -webkit-transform: translateX(0%);
}

#header.top>#navigation {
  position: relative;
  width: 34rem;
  height: 3rem;
  top: 0;
  left: 0;
  margin-top: 0rem;
  border-top: 1px solid #8c8c8c;
}

#navigation .nav {
  display: block;
  position: relative;
  float: left;
  clear: both;
  padding: 0.5rem 0.5rem 0.5rem 0rem;
  margin: 0.5rem 0.5rem 0.5rem 0.5rem;
  clear: none;
  cursor: pointer;
  font-weight: 600;
  text-decoration: none;
  outline: none;
}

#navigation>#indicator {
  display: none;
  position: absolute;
  bottom: 0;
  left: 4px;
  width: 4px;
  border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  background-color: rgba(0, 0, 0, 1);
  transition-property: top, background-color, height;
  -o-transition-property: top, background-color, height;
  -ms-transition-property: top, background-color, height;
  -moz-transition-property: top, background-color, height;
  -webkit-transition-property: top, background-color, height;
  transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  -ms-transition-duration: 0.3s;
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  -ms-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -webkit-transition-timing-function: ease-out;
}

#header.bottom>#navigation .nav {
  margin: 0.5rem 0rem 0.5rem 0rem;
  clear: both;
}

#header.bottom>#navigation #indicator {
  display: block;
}

#header.bottom>#navigation .nav {
  width: 100%;
  text-align: left;
}

#menu {
  position: absolute;
  top: 0.7em;
  left: 0.8em;
  width: 2.6em;
  height: 2.6em;
  opacity: 1;
  pointer-events: all;
  cursor: pointer;
  z-index: 5;
  transition: opacity 0.3s ease-out;
  -o-transition: opacity 0.3s ease-out;
  -ms-transition: opacity 0.3s ease-out;
  -moz-transition: opacity 0.3s ease-out;
  -webkit-transition: opacity 0.3s ease-out;
}

#menu>div {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#menu>div>div {
  position: absolute;
  width: 90%;
  height: 0.2rem;
  background-color: #bbb;
  border-radius: 0.2em;
  transition: all 0.15s ease-out;
  -o-transition: all 0.15s ease-out;
  -ms-transition: all 0.15s ease-out;
  -moz-transition: all 0.15s ease-out;
  -webkit-transition: all 0.15s ease-out;
}

#menu>div>div:first-child {
  top: 18%;
  left: 5%;
}

#menu>div>div:nth-child(2) {
  top: 45%;
  left: 5%;
}

#menu>div>div:last-child {
  top: 71%;
  left: 5%;
}

#menu.active>div>div:first-child {
  transform: rotate(45deg);
  top: 40%;
  left: 5%;
}

#menu.active>div>div:nth-child(2) {
  top: 50%;
  left: 105%;
}

#menu.active>div>div:last-child {
  transform: rotate(-45deg);
  top: 40%;
  left: 5%;
}

#menu>svg {
  width: 100%;
  height: 100%;
  stroke: #bbb;
  stroke-width: 2;
  stroke-linecap: round;
}

#header.top>#menu {
  opacity: 0;
  pointer-events: none;
}

#landing {
  min-height: 100vh;
  opacity: 0.15;
  background-image: url("~@/assets/tree.svg");
  background-size: auto 110vh;
  background-color: #c9e4e6;
  background-position: center top;
  background-repeat: no-repeat;
  border-bottom: 1rem solid #00828c;
}

#footer {
  position: relative;
  padding-top: 2em;
  padding-bottom: 2em;
  color: #fff;
  font-size: 1.1em;
  font-weight: 600;
}

#footer>div {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.1;
  border-bottom: 0.5rem solid #000000;
  box-sizing: border-box;
  background-image: url("~@/assets/insight-pattern-grey.svg");
  background-repeat: repeat;
  background-size: 4rem auto;
}

.pattern {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.1;
  box-sizing: border-box;
  background-image: url("~@/assets/insight-pattern-grey.svg");
  background-repeat: repeat;
  background-size: 4rem auto;
}

#therapy>.pattern {
  opacity: 0.05;
  background-size: 4rem auto;
}

#fees>.pattern {
  background-image: url("~@/assets/celtic-pattern.svg");
  background-size: auto 30vh;
  background-position: center top;
  background-repeat: repeat-x;
}

#fees>.visual {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0.2;
}

#welcome>.pattern {
  opacity: 0.1;
  background-image: url("~@/assets/celtic-pattern-blue.svg");
  background-size: 50vw auto;
  background-position: center top;
  background-repeat: repeat-y;
}

#background {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #eee;
  transition-property: background-color;
  -o-transition-property: background-color;
  -ms-transition-property: background-color;
  -moz-transition-property: background-color;
  -webkit-transition-property: background-color;
  transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  -ms-transition-duration: 0.3s;
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  -ms-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -webkit-transition-timing-function: ease-out;
}

#background.therapy {
  background-color: #eee;
  /* background-color: #634a91; */
}

#background.counselling {
  background-color: #eee;
  /* background-color: #00828c; */
}

#background.fees {
  background-color: #eee;
}

#background.contact {
  background-color: #eee;
  /* background-color: #9e005d; */
}

#profile {
  margin-left: 2rem;
  float: right;
  width: 33%;
  overflow: hidden;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
}

#profile>img {
  width: 100%;
  float: left;
}

#tree {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  height: 200%;
  opacity: 0.1;
  transform: translate(-50%, -15%);
  -moz-transform: translate(-50%, -15%);
  -webkit-transform: translate(-50%, -15%);
}

#contact {
  background-color: #fff;
}

.assoc {
  height: 4rem;
  margin: 0.5rem 1rem 0.5rem 0rem;
}

.assoc:last-child {
  margin-right: 0.5rem;
}

/* Pages */

.page {
  position: relative;
  float: left;
  width: 100%;
  min-height: 100vh;
  padding-bottom: 5em;
  box-sizing: border-box;
  overflow: hidden;
  transition: padding-left 0.2s ease-out;
  -o-transition: padding-left 0.2s ease-out;
  -ms-transition: padding-left 0.2s ease-out;
  -moz-transition: padding-left 0.2s ease-out;
  -webkit-transition: padding-left 0.2s ease-out;
}

.page,
.pattern,
.title {
  transition-property: background-color, color, border-top, border-bottom;
  -o-transition-property: background-color, color, border-top, border-bottom;
  -ms-transition-property: background-color, color, border-top, border-bottom;
  -moz-transition-property: background-color, color, border-top, border-bottom;
  -webkit-transition-property: background-color, color, border-top,
    border-bottom;
  transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  -ms-transition-duration: 0.3s;
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  -ms-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -webkit-transition-timing-function: ease-out;
}

.page:last-child {
  padding-bottom: 0;
}

.page .content {
  position: relative;
  width: 70%;
  box-sizing: border-box;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.page .content>.title {
  position: relative;
  float: left;
  width: 100%;
  font-weight: 700;
  font-size: 3rem;
  padding-top: 1.5rem;
  z-index: 1;
  border-radius: 4px 4px 0px 0px;
  margin: 0;
}

.page .content>.title:before {
  display: block;
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  width: 0%;
  border-bottom: 1px solid #808080;
  transition: left 1s ease-out, width 1s ease-out;
  -o-transition: left 1s ease-out, width 1s ease-out;
  -ms-transition: left 1s ease-out, width 1s ease-out;
  -moz-transition: left 1s ease-out, width 1s ease-out;
  -webkit-transition: left 1s ease-out, width 1s ease-out;
}

.page.current .content>.title:before {
  left: 20%;
  width: 60%;
}

#therapy.page .content>.title:before,
#fees.page .content>.title:before {
  border-color: #d6d6d6;
}

.page .content>.sub-title {
  position: relative;
  float: left;
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 0rem;
  font-size: 1.5rem;
  font-weight: 300;
  color: #828282;
  z-index: 1;
}

.page .content>.text {
  position: relative;
  float: left;
  width: 100%;
  padding: 2em;
  box-sizing: border-box;
  z-index: 1;
  border-radius: 0px 0px 4px 4px;
}

#contact {
  min-height: 0;
}

/* Grid */

.grid {
  position: relative;
  float: left;
  box-sizing: border-box;
  padding: 0rem 0.5rem 0rem 0.5rem;
  text-align: left;
}

.grid.full {
  width: 100%;
}

.grid.half {
  width: 50%;
}

.grid.thrd {
  width: 33.3%;
}

.grid.two-thrd {
  width: 66.6%;
}

.grid.qtr {
  width: 25%;
}

.grid.half:first-child,
.grid.thrd:first-child,
.grid.two-thrd:first-child {
  padding-left: 0;
}

.grid.half:last-child,
.grid.thrd:last-child,
.grid.two-thrd:last-child {
  padding-right: 0;
}

/* Text */

a {
  text-decoration: none;
  font-weight: 700;
  color: #9e005d;
  font-size: 0.9rem;
}

a:hover {
  text-decoration: underline;
}

a:visited {
  color: #9e005d;
}

#therapy a {
  text-decoration: none;
  font-weight: 700;
  color: #fff;
}

#therapy a:hover {
  text-decoration: underline;
}

#therapy a:visited {
  color: #fff;
}

#counselling a {
  text-decoration: none;
  font-weight: 700;
  color: #00828c;
}

#counselling a:hover {
  text-decoration: underline;
}

#counselling a:visited {
  color: #00828c;
}

blockquote {
  position: relative;
  font-size: 1.7rem;
  font-weight: 700;
  margin: 0;
  padding: 1rem;
}

blockquote>span:last-child {
  font-size: 1.6rem;
  font-weight: 300;
  color: #828282;
}

/* General */

.left {
  float: left;
}

.right {
  float: right;
}

/* Loader */

#loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  opacity: 1;
  z-index: 100;
  pointer-events: none;
  transition: opacity 0.5s ease-out;
  -o-transition: opacity 0.5s ease-out;
  -ms-transition: opacity 0.5s ease-out;
  -moz-transition: opacity 0.5s ease-out;
  -webkit-transition: opacity 0.5s ease-out;
}

#loader.hidden {
  opacity: 0;
}

@media (max-width: 1400px) {
  .page .content {
    width: 80%;
  }
}

@media (max-width: 1000px) {
  .grid.thrd {
    width: 100%;
    padding: 0rem;
  }
}

@media (max-width: 800px) {

  #header.top #navigation {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }

  #header.top #navigation>.nav {
    width: 100%;
    padding-bottom: 0.5rem;
  }

  #header.bottom.mobile {
    padding-bottom: 0.5rem;
  }

  .page.current .content>.title:before {
    left: 5%;
    width: 90%;
  }

  .grid.full,
  .grid.half,
  .grid.thrd,
  .grid.two-thrd,
  .grid.qtr {
    width: 100%;
    padding: 0rem;
  }

  .page .content {
    width: 100%;
  }

  #fees>.visual {
    width: 200%;
  }
}
</style>
